
export interface ElementMeasure {
	/* Position relative to viewport */
    viewTop: number, viewLeft: number,
	viewportWidth:number, viewportHeight:number,
	/* Scroll of the view port */
    scrollTop: number, scrollLeft: number,
	/* Position relative to document */
    top: number, left: number, width: number, height: number,
    /* How far is the element from the edges of the viewport */
    spaceTop: number, spaceLeft: number, spaceRight: number, spaceBottom: number,
    /** Height of entire document */
    docHeight: number
}

export function viewPort() {
	const html = document.documentElement;
	const viewportWidth = window.innerWidth || html.clientWidth;
	const viewportHeight = window.innerHeight || html.clientHeight;
	return {
		width: viewportWidth,
		height: viewportHeight
	}
}

export function getElementMeasure(el: HTMLElement):ElementMeasure {
    const rect = el.getBoundingClientRect();

    const body = document.body;
    const html = document.documentElement;

    const scrollTop = window.scrollY || html.scrollTop;
    const scrollLeft = window.scrollX || html.scrollLeft;

    const viewportWidth = window.innerWidth || html.clientWidth;
    const viewportHeight = window.innerHeight || html.clientHeight;

    return {
        viewTop: rect.top,
        viewLeft: rect.left,
        viewportWidth: viewportWidth,
        viewportHeight: viewportHeight,
        scrollTop: scrollTop,
        scrollLeft: scrollLeft,
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft,
        width: rect.width,
        height: rect.height,
        spaceBottom: viewportHeight - rect.bottom,
        spaceLeft: rect.left,
        spaceRight: viewportWidth - rect.right,
        spaceTop: rect.top,
        docHeight: Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight )
    };
}
